import React, { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export default function SignaturePad({ onChange, height = 180 }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio; c.height = height * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0B0D12";
  }, [height]);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - r.left, y: p.clientY - r.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => {
    if (!drawing.current) return; e.preventDefault();
    const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.lineTo(x, y); ctx.stroke();
    if (empty) setEmpty(false);
  };
  const end = () => {
    if (!drawing.current) return; drawing.current = false;
    onChange?.(empty ? "" : canvasRef.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = canvasRef.current; const ctx = c.getContext("2d");
    ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, c.width, c.height); ctx.restore();
    setEmpty(true); onChange?.("");
  };

  return (
    <div className="relative">
      <canvas
        ref={canvasRef}
        data-testid="signature-canvas"
        style={{ height, touchAction: "none" }}
        className="w-full rounded-xl bg-white border-2 border-dashed border-[#D1D5DB] cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      {empty && <div className="absolute inset-0 flex items-center justify-center pointer-events-none text-sm text-[#9CA3AF]">Firma aquí con el dedo o el mouse</div>}
      <button type="button" data-testid="signature-clear" onClick={clear} className="absolute top-2 right-2 inline-flex items-center gap-1 text-xs text-[#6B7280] hover:text-[#111] bg-white/90 rounded-lg px-2 py-1 border border-[#E5E7EB]">
        <Eraser className="w-3.5 h-3.5"/> Limpiar
      </button>
    </div>
  );
}
